import {mutation, query} from "@/graphql/client";
import {PayrollStatus} from "@/graphql/generated/graphql";
import {kapitelDateString, kapitelMonthString} from "@/graphql/kapitelTypes";
import {graphql} from "@/graphql/generated";

export const payrollStatusFragment = graphql(` fragment PayrollStatusFragment on PayrollStatus {    
    month            
    
    # labor cost components
    pk1 {...MoneyFragment}    
    
    # employee revenue
    revenue {...MoneyFragment}
    # revenue - labor cost
    dB1 {...MoneyFragment}        
               
    seen
    
    # additional data
    workedHours
    basisHourlyWage {...MoneyFragment}
    typicalWorkersMonthlyHours
}`)

// export const bonusHistoryItemFragment = graphql(` fragment BonusHistoryItemFragment on BonusHistoryItem {
//     month
//     previousMonthCumulativeDeposit  {...MoneyFragment}
//     productivityBonusDeposit  {...MoneyFragment}
//     recruitmentCashbackDeposit  {...MoneyFragment}
// }`)


export async function fetchPayrollStatusForMonth(month: kapitelDateString): Promise<PayrollStatus> {
    const result = await query(
        graphql(`
            query getPayrollStatus($month: KapitelDateImmutable!) {            
            payrollStatusForMonth(month: $month) {
                ...PayrollStatusFragment
            }
        }`),
        {month}
    )

    return result.data.payrollStatusForMonth
}

export async function fetchPayrollStatusList(months: kapitelDateString[]): Promise<PayrollStatus[]> {
    const result = await query(
        graphql(`
            query getPayrollStatusList($months: [KapitelDateImmutable!]!) {            
            payrollStatusList(months: $months) {
                ...PayrollStatusFragment
            }
        }`),
        {months}
    )

    return result.data.payrollStatusList
}


export async function setPayrollStatusSeen(month: kapitelMonthString): Promise<any> {
    const MUTATION = graphql(`
        mutation SetPayrollStatusSeen (
            $month: KapitelDateImmutable!
        ) {
            setPayrollStatusSeen(
                month: $month,
            )
        }`)

    const result = await mutation(
        MUTATION, {month}
    )

    return result?.data?.setPayrollStatusSeen
}

// export async function fetchBonusHistory(beginMonth: kapitelDateString, untilMonth: kapitelDateString): Promise<BonusHistoryItem[]> {
//     const result = await query(
//         graphql(`
//             query getPayrollStatus($month: KapitelDateImmutable!) {
//             payrollStatusForMonth(month: $month) {
//                 ...PayrollStatusFragment
//             }
//         }`),
//         {month}
//     )
//
//     return result.data.payrollStatus
// }
